import {Linq, PageContentTitle, Pager, ScrollTable, Searchbar} from "../../ui";
import {convertDocumentType, displayShipmentProcessType, displayShipmentType} from "../../../api";
import {ShipmentListItemDto, ShipmentListSortByDto} from "../../../api/fms";
import {useNavigate, useSearchParams} from "react-router";
import {formatAddressLine, getShipmentListItemStatus} from "./FmsUtil";
import {FmsItemFilterbar} from "./FmsItemFilterbar";
import {pageQueryStore} from "../../../store";
import {useEffect} from "react";
import {dateFormat} from "../../../utils";
import {SortableTableHeader} from "../../ui/SortableTableHeader";

interface  FmsShipmentItemListProps {
    items: ShipmentListItemDto[]
    pages: number
}


function FmsShipmentItemList({
    items, pages
                                                                  } : FmsShipmentItemListProps) {
    const navigate = useNavigate()

    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        pageQueryStore.restore('fms', searchParams, setSearchParams)
    }, [searchParams, setSearchParams])

    return <>
        <PageContentTitle
            actionItem={<FmsItemFilterbar />}
        >
            <Searchbar placeholder={"FIN, Scancode oder Akte"}/>
        </PageContentTitle>
        <ScrollTable>
            <thead>
            <tr>
                <th>Kunde</th>
                <SortableTableHeader field={ShipmentListSortByDto.LAST_MODIFIED}>Datum</SortableTableHeader>
                <SortableTableHeader field={ShipmentListSortByDto.VIN}>FIN</SortableTableHeader>
                <th>Dokumentenart</th>
                <th>Versandadresse</th>
                <SortableTableHeader field={ShipmentListSortByDto.SHIPMENT_TYPE}>Versandart</SortableTableHeader>
                <SortableTableHeader field={ShipmentListSortByDto.PROCESS_TYPE}>Prozess</SortableTableHeader>
                <th style={{textAlign: 'end', width: '4.5em', paddingRight: '2em'}}>Status</th>
                <th> {/*Status Text*/} </th>
            </tr>
            </thead>
            <tbody>
            {items.map((val, index) => {
                const target = `/fms/packages/${val.packageId}`
                const status = getShipmentListItemStatus(val)

                return <tr key={index} style={{cursor: 'pointer'}} onClick={() => {
                    navigate(target)
                }}>
                    <td><Linq to={target}>{val.customerDisplay}</Linq></td>
                    <td><Linq to={target}>{dateFormat(val.auditInfo.createdDate)}</Linq></td>
                    <td title={val.vin}><Linq to={target}>{val.vin}</Linq></td>
                    <td><Linq to={target}>{convertDocumentType(val.documentType)}</Linq></td>
                    <td title={formatAddressLine(val.receiver)}><Linq to={target}>{formatAddressLine(val.receiver)}</Linq></td>
                    <td><Linq to={target}>{displayShipmentType(val.shipmentType)}</Linq></td>
                    <td><Linq to={target}>{displayShipmentProcessType(val.process)}</Linq></td>
                    <td style={{textAlign: 'end', paddingRight: '2em'}}>
                        <span className={`material-symbols-outlined ${status.cls}`} title={status.text} style={{flexShrink: 0}}> radio_button_checked</span>
                    </td>
                    <td>{status.text}</td>
                </tr>
            })}
            </tbody>
        </ScrollTable>
        <Pager total={pages}/>
    </>
}

export {
    FmsShipmentItemList
}
